module.exports = __webpack_public_path__ + "img/icon_outside.93b4d2d.svg";